import classNames from "classnames";
import { BasicTable } from "../../../atoms/BasicTable";
import { decodeToken } from "utils/functions/decodeToken";
import { getOfficeHoursDisplayName } from "utils/functions/getOfficeHoursDisplayName";
import "./progress-summary-table.scss";

interface IProps {
    data?: any;
}

interface TestData {
    courseItem: string;
    complete: string;
    incomplete: string;
    upcoming: string;
    isShow:boolean;
}

export const ProgressSummaryTable = ({ data }: IProps) => {
    const payload = decodeToken();
    const testType = payload?.testtype || "";
    // const tableData: TestData[] = [
    //     {
    //         courseItem: "Diagnostic Exams",
    //         complete: data && "DiagnosticsCompletedCount" in data && data.DiagnosticsCompletedCount,
    //         incomplete: data && "DiagnosticsIncompleteCount" in data && data.DiagnosticsIncompleteCount,
    //         upcoming: data && "DiagnosticsUpcomingCount" in data && data.DiagnosticsUpcomingCount,
    //         isShow:data && "ShowDiagnostics" in data && data.ShowDiagnostics
    //     },
    //     {
    //         courseItem: "Attendance",
    //         complete: data && "AttendanceCompletedCount" in data && data.AttendanceCompletedCount,
    //         incomplete: data && "AttendanceIncompleteCount" in data && data.AttendanceIncompleteCount,
    //         upcoming: data && "AttendanceUpcomingCount" in data && data.AttendanceUpcomingCount,
    //         isShow:data && "ShowAttendance" in data && data.ShowAttendance
    //     },
    //     {
    //         courseItem: "Homework",
    //         complete: data && "HomeworkCompletedCount" in data && data.HomeworkCompletedCount,
    //         incomplete: data && "HomeworkIncompleteCount" in data && data.HomeworkIncompleteCount,
    //         upcoming: data && "HomeworkUpcomingCount" in data && data.HomeworkUpcomingCount,
    //         isShow:data && "ShowHomework" in data && data.ShowHomework
    //     },
    //     {
    //         courseItem: "Test",
    //         complete: data && "TestsCompletedCount" in data && data.TestsCompletedCount,
    //         incomplete: data && "TestsIncompleteCount" in data && data.TestsIncompleteCount,
    //         upcoming: data && "TestsUpcomingCount" in data && data.TestsUpcomingCount,
    //         isShow:data && "ShowTests" in data && data.ShowTests
    //     },
    //     {
    //         courseItem: "Topic Focus",
    //         complete: data && "TopicFocusCompletedCount" in data && data.TopicFocusCompletedCount,
    //         incomplete: data && "TopicFocusIncompleteCount" in data && data.TopicFocusIncompleteCount,
    //         upcoming: data && "TopicFocusUpcomingCount" in data && data.TopicFocusUpcomingCount,
    //         isShow:data && "ShowTopicFocus" in data && data.ShowTopicFocus
    //     }
    // ];

    // const tableData: TestData[] = [
    //     {
    //         courseItem: "Diagnostic Exams",
    //         complete: data && "DiagnosticsCompletedCount" in data && data.DiagnosticsCompletedCount,
    //         incomplete: data && "DiagnosticsIncompleteCount" in data && data.DiagnosticsIncompleteCount,
    //         upcoming: data && "DiagnosticsUpcomingCount" in data && data.DiagnosticsUpcomingCount,
    //         isShow:data && "ShowDiagnostics" in data && data.ShowDiagnostics
    //     },
    //     {
    //         courseItem: "Attendance",
    //         complete: data && "AttendanceCompletedCount" in data && data.AttendanceCompletedCount,
    //         incomplete: data && "AttendanceIncompleteCount" in data && data.AttendanceIncompleteCount,
    //         upcoming: data && "AttendanceUpcomingCount" in data && data.AttendanceUpcomingCount,
    //         isShow:data && "ShowAttendance" in data && data.ShowAttendance
    //     },
    //     {
    //         courseItem: "Homework",
    //         complete: data && "HomeworkCompletedCount" in data && data.HomeworkCompletedCount,
    //         incomplete: data && "HomeworkIncompleteCount" in data && data.HomeworkIncompleteCount,
    //         upcoming: data && "HomeworkUpcomingCount" in data && data.HomeworkUpcomingCount,
    //         isShow:data && "ShowHomework" in data && data.ShowHomework
    //     },
    //     {
    //         courseItem: "Test",
    //         complete: data && "TestsCompletedCount" in data && data.TestsCompletedCount,
    //         incomplete: data && "TestsIncompleteCount" in data && data.TestsIncompleteCount,
    //         upcoming: data && "TestsUpcomingCount" in data && data.TestsUpcomingCount,
    //         isShow:data && "ShowTests" in data && data.ShowTests
    //     },
    //     {
    //         courseItem: "Topic Focus",
    //         complete: data && "TopicFocusCompletedCount" in data && data.TopicFocusCompletedCount,
    //         incomplete: data && "TopicFocusIncompleteCount" in data && data.TopicFocusIncompleteCount,
    //         upcoming: data && "TopicFocusUpcomingCount" in data && data.TopicFocusUpcomingCount,
    //         isShow:data && "ShowTopicFocus" in data && data.ShowTopicFocus
    //     }
    // ];

    const tableData: TestData[] = []

    if(data && "ShowDiagnostics" in data && data.ShowDiagnostics){
        tableData.push({
            courseItem: "Diagnostic Exams",
            complete: data && "DiagnosticsCompletedCount" in data && data.DiagnosticsCompletedCount,
            incomplete: data && "DiagnosticsIncompleteCount" in data && data.DiagnosticsIncompleteCount,
            upcoming: data && "DiagnosticsUpcomingCount" in data && data.DiagnosticsUpcomingCount,
            isShow:data && "ShowDiagnostics" in data && data.ShowDiagnostics
        })
    }

    if(data && "ShowAttendance" in data && data.ShowAttendance){
        tableData.push({
            courseItem: "Attendance",
            complete: data && "AttendanceCompletedCount" in data && data.AttendanceCompletedCount,
            incomplete: data && "AttendanceIncompleteCount" in data && data.AttendanceIncompleteCount,
            upcoming: data && "AttendanceUpcomingCount" in data && data.AttendanceUpcomingCount,
            isShow:data && "ShowAttendance" in data && data.ShowAttendance
        })
    }

    if(data && "ShowHomework" in data && data.ShowHomework){
        tableData.push({
            courseItem: "Homework",
            complete: data && "HomeworkCompletedCount" in data && data.HomeworkCompletedCount,
            incomplete: data && "HomeworkIncompleteCount" in data && data.HomeworkIncompleteCount,
            upcoming: data && "HomeworkUpcomingCount" in data && data.HomeworkUpcomingCount,
            isShow:data && "ShowHomework" in data && data.ShowHomework
        })
    }

    if(data && "ShowTests" in data && data.ShowTests){
        tableData.push({
            courseItem: "Test",
            complete: data && "TestsCompletedCount" in data && data.TestsCompletedCount,
            incomplete: data && "TestsIncompleteCount" in data && data.TestsIncompleteCount,
            upcoming: data && "TestsUpcomingCount" in data && data.TestsUpcomingCount,
            isShow:data && "ShowTests" in data && data.ShowTests
        })
    }

    if(data && "ShowTopicFocus" in data && data.ShowTopicFocus){
        tableData.push({
            courseItem: getOfficeHoursDisplayName(testType),
            complete: data && "TopicFocusCompletedCount" in data && data.TopicFocusCompletedCount,
            incomplete: data && "TopicFocusIncompleteCount" in data && data.TopicFocusIncompleteCount,
            upcoming: data && "TopicFocusUpcomingCount" in data && data.TopicFocusUpcomingCount,
            isShow:data && "ShowTopicFocus" in data && data.ShowTopicFocus
        })
    }

    return (
        <BasicTable
            columns={[
                { title: "Course Item", key: "courseItem" },
                { title: "Complete", key: "complete" },
                { title: "Incomplete", key: "incomplete" },
                { title: "Upcoming", key: "upcoming" }
            ]}
            data={tableData && tableData}
            renderHead={(customColumns) => (
                <thead className={classNames("progress-summary-thead")}>
                    <tr>
                        {customColumns.map((obj, index) => (
                            <th
                                key={index + obj.title}
                                className={classNames({
                                    'courseItem': obj.key === "courseItem",
                                    'complete': obj.key === "complete",
                                    'incomplete': obj.key === "incomplete",
                                    'upcoming': obj.key === "upcoming"
                                })}
                            >
                                {obj.title}
                            </th>
                        ))}
                    </tr>
                </thead>
            )}
            renderBody={(customData) => (
                <tbody className={classNames("progress-summary-tbody")}>
                    {customData.map((obj, index, array) => (
                       <tr key={index} className={classNames({ "highlight-row": index % 2 === 0 })}>
                            {Object.keys(obj).map((columnName, innerIndex) => (
                                <td
                                    key={innerIndex + columnName}
                                    className={classNames({
                                        'complete': columnName === "complete",
                                        'incomplete': columnName === "incomplete",
                                        'upcoming': columnName === "upcoming",
                                        'last': (index + 1) === array.length
                                    })}
                                >
                                    {obj[columnName as keyof TestData]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            )}
        />
    );
};